import type { ProductNutrientInformation } from '../../../../../../common/models/props/itemTeaserProps';

const unitsMap = new Map<string, { long: string; short: string }>([
    ['B60', { long: 'Lumens per Square Meter', short: 'lm/m²' }],
    ['ANN', { long: 'Year', short: 'år' }],
    ['CEL', { long: 'Degree Celsius', short: '°C' }],
    ['CMT', { long: 'Centimetre', short: 'cm' }],
    ['E14', { long: 'Kilokalori', short: 'kcal' }],
    ['GL', { long: 'Gram Per Litre', short: 'g/l' }],
    ['GRM', { long: 'Gram', short: 'g' }],
    ['H87', { long: 'Piece', short: 'st' }],
    ['HUR', { long: 'Hour', short: 'tim' }],
    ['INH', { long: 'Inches', short: 'tum' }],
    ['KGM', { long: 'Kilogram', short: 'kg' }],
    ['KJO', { long: 'Kilojoule', short: 'kJ' }],
    ['LUX', { long: 'Lux', short: 'lux' }],
    ['MC', { long: 'Mikrogram', short: 'μg' }],
    ['MGM', { long: 'Milligram', short: 'mg' }],
    ['MLT', { long: 'Millilitre', short: 'ml' }],
    ['MMT', { long: 'Millimetre', short: 'mm' }],
    ['MON', { long: 'Month', short: 'månad' }],
    ['MTK', { long: 'Square metre', short: 'm²' }],
    ['MTQ', { long: 'Cubic metre', short: 'm³' }],
    ['P1', { long: 'Percent', short: '%' }],
]);

export const getUnitShortValue = (code?: string) => {
    if (!code) return '';

    const shortUnit = unitsMap.get(code);
    return shortUnit?.short || code;
};

// helper function, remove when AS give us unit codes
export const getUnitShortFromLongValue = (longValue?: string) => {
    if (!longValue) return '';

    const shortUnit = Array.from(unitsMap.values()).find(
        (unit) => unit.long.toLowerCase() === longValue.toLowerCase(),
    );

    return shortUnit?.short || longValue;
};

export const getNutrientBasis = (nutrientInformation?: ProductNutrientInformation['header']) => {
    return (
        nutrientInformation &&
        `${nutrientInformation.nutrientBasisQuantity} ${getUnitShortValue(
            nutrientInformation.nutrientBasisQuantityUnit?.code,
        )}`
    );
};

const schemaPropMap: Record<string, string> = {
    energi: 'calories',
    fett: 'fatContent',
    'varav mättat fett': 'saturatedFatContent',
    'varav fleromättat fett': 'unsaturatedFatContent',
    kolhydrat: 'carbohydrateContent',
    protein: 'proteinContent',
    nacl: 'sodiumContent',
    fiber: 'fiberContent',
    'varav sockerarter': 'sugarContent',
};

export const getSchemaPropName = (name: string) => {
    if (!name) return null;

    const propName = schemaPropMap[name.toLowerCase().trim()];
    return propName;
};
